import { APICore } from "./apiCore";

const api = new APICore();

// Get Stalls
function getStalls(vendorId?: number) {
    return api.get(
        "/vendors/stalls",
        vendorId ? { vendorId } : {}
    );
}

// Get Stall By Id
function getStallById(stallId: number) {
    return api.get(`/vendors/stalls/${stallId}`, "");
}

// Create Stall
function createStall(payload: any) {
    const { vendorId, ...body } = payload;
    return api.create(`/vendors/${vendorId}/stalls`, body);
}

function updateStall(
    stallId: number,
    originalVendorId: number,
    payload: any
) {
    return api.updatePatch(
        `/vendors/${originalVendorId}/stalls/${stallId}`,
        payload
    );
}

// Delete Stall
function deleteStall(vendorId: number, stallId: number) {
    return api.delete(`/vendors/${vendorId}/stalls/${stallId}`);
}

// Assign Stock
function assignStockToStall(stallId: number, payload: { productId: string; quantity: number }) {
    return api.create(`/vendors/stalls/${stallId}/stock`, payload);
}

export {
    getStalls,
    getStallById,
    createStall,
    updateStall,
    deleteStall,
    assignStockToStall,
};